<div class="title">
  <div class="label">{{ label }}</div>

  @if (info || icon) {
    <mat-icon mat-list-icon matTooltipPosition="right" [matTooltip]="info" [class.warn]="iconColor === 'warn'" (click)="clicked.emit()">{{
      icon ? icon : 'info'
    }}</mat-icon>
  }
</div>
<ng-content></ng-content>
